export enum Sex {
  Unknow = 0,
  Man = 1,
  Woman = 2
}
